import { Container } from "@/components/Blog/Layout";
import type { LayoutProps } from "@cgc/ui/layout";
import React from "react";

const FilterContainer: React.FC<LayoutProps> = ({ children, ...props }) => (
  <Container {...props}>
    <div className="border-b-cgc-green border-t-cgc-green flex flex-wrap justify-center gap-5 border-b-[1px] border-t-[1px] py-2">
      {children}
    </div>
  </Container>
);

export default FilterContainer;
